import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import moment from "moment";
import toast from "react-hot-toast";
import TimeRangeSlider from "react-time-range-slider";
import axios from "axios";
import api from "../lib/axios";
import "../styles/css/Global-Style.css";
import "../styles/css/Pick_a_date.css";
import bookingService from "../services/bookingsService/index";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

// Lifted out of PickDate so the component identity is stable across re-renders.
// When defined inside the function body, React.forwardRef returns a NEW
// component on every render — the DatePicker would then unmount/remount its
// popup and lose open/close state (audit MEDIUM 8).
const DateCustomInput = React.forwardRef(({ value, onClick }, ref) => (
  <button className="date-custom-input" onClick={onClick} ref={ref}>
    {value}
  </button>
));

export default function PickDate(props) {
  let now = new Date();
  var dateString = moment(now).format("yyyy-MM-DD");
  //var start_of_web = moment("2022-04-01");
  var minDate = moment(now).format("yyyy-MM-DD");
  /* if (moment(now).diff(start_of_web, "days") < 0) {
    minDate = moment("2022-04-01").format("yyyy-MM-DD");
  } */
  var maxDate = moment(now).add(7, "days").format("yyyy-MM-DD");
  const [datevalue, setDateValue] = useState(dateString);
  const [minDateValue, setMinDateValue] = useState(minDate);
  const [maxDateValue, setMaxDateValue] = useState(maxDate);
  const [timerangevalue, setTimeRangeValue] = useState({
    start: "06:00",
    end: "20:00",
  });
  const [defaultTimeRange, setDefaultTimeRange] = useState({
    start: "06:00",
    end: "20:00",
  });

  // useRef instead of createRef — createRef in a function body produces a
  // fresh ref object on every render and is almost never what you want.
  const ref = useRef(null);

  const [player, setPlayerValue] = useState("");
  const [rate, setRateValue] = useState("");
  const [errormsg, setErrorMsg] = useState("");
  const [allSlots, setAllSlots] = useState([]);
  const [loadingSlots, setLoadingSlots] = useState(false);
  const [existingusermembership, setExistingUserMembership] = useState(false);
  const [usermembershipData, setUsermembershipData] = useState();
  const [bookingAllowed, setBookingAllowed] = useState(true);
  const [isFMember, setIsFMember] = useState(true);
  // Site-wide visitor-booking policy (single source of truth lives on the
  // backend at api::site-settings.site-settings). 1 = no minimum.
  const [visitorMinPlayers, setVisitorMinPlayers] = useState(1);
  const [visitorBookingEnabled, setVisitorBookingEnabled] = useState(true);
  // Per-slot visitor minimum for the selected date: { [slotId]: minimum }.
  // Resolved server-side from the day/time visitor-min-rule set; falls back to
  // the global `visitorMinPlayers` for any slot not present in the map.
  const [slotMinMap, setSlotMinMap] = useState({});
  // Shared-tee-time consent modal: null, or { context, playerCount, slotDetails }.
  const [consentModal, setConsentModal] = useState(null);
  const [consentChecked, setConsentChecked] = useState(false);
  // Per-slot tee-sharing state for the date + this booker's audience:
  // { [slotId]: { shareable, joinable, hide } }. Sharing is only allowed inside
  // an active tee-sharing-rule window; outside, a tee time is exclusive.
  const [sharingMap, setSharingMap] = useState({});
  const { nextStep, values, setFormData } = props;
  let teeTimeHeading = "";
  let previousSlot = {};
  const token = localStorage.getItem("token");
  let username = "";
  if (token) {
    username = JSON.parse(localStorage.getItem("userData")).email;
  }
  // Removed: `values.hasUserMembership = false;` was being assigned during
  // render on every paint, racing the async membership loader that flips it
  // to `true`. The initial-false default is now handled inside the membership
  // load effect (audit MEDIUM 9).

  const changeCompleteHandler = (time) => {
    let start_time = time.start.hours + ":" + time.start.minutes;
    let end_time = time.end.hours + ":" + time.end.minutes;
    if (start_time.length == 4) {
      start_time = "0" + start_time;
    }
    if (end_time.length == 4) {
      end_time = "0" + end_time;
    }

    setTimeRangeValue({ start: start_time, end: end_time });

    let selectedDay = moment(datevalue).format("dddd");
    //if (moment(datevalue).diff(start_of_web, "days") >= 0) {
    checkBankHoliday("").then(({ isBankHoliday, availableforCurrentMem }) => {
      if (!isBankHoliday) {
        if (usermembershipData.attributes[selectedDay]) {
          getTimeSlotData("", start_time, end_time);
        } else {
          setAllSlots([]);
        }
      } else {
        if (availableforCurrentMem) {
          getTimeSlotData("", start_time, end_time);
        } else {
          setAllSlots([]);
        }
      }
    });
    /* } else {
      setAllSlots([]);
    } */
  };

  const timeChangeHandler = (time) => {
    setTimeRangeValue(time);
  };

  const dateChangeHandler = (dateval) => {
    setDateValue(dateval);
    let selectedDay = moment(dateval).format("dddd");
    //if (moment(dateval).diff(start_of_web, "days") >= 0) {

    if (usermembershipData && usermembershipData.hasOwnProperty("attributes")) {
      checkBankHoliday(dateval).then(
        ({ isBankHoliday, availableforCurrentMem }) => {
          if (!isBankHoliday) {
            if (usermembershipData.attributes[selectedDay]) {
              getTimeSlotData(dateval);
            } else {
              setAllSlots([]);
            }
          } else {
            if (availableforCurrentMem) {
              getTimeSlotData(dateval);
            } else {
              setAllSlots([]);
            }
          }
        }
      );
    } else {
      setAllSlots([]);
    }

    /* } else {
      setAllSlots([]);
    } */
  };

  const storePlayerAndRate = (
    playercount,
    playerrate,
    slotstarttime,
    selectedslotid
  ) => {
    setPlayerValue(playercount);
    setRateValue(playerrate);
    values.date = datevalue;
    values.time = timerangevalue;
    values.start_time = timerangevalue.start;
    values.end_time = timerangevalue.end;
    values.selectedslot = slotstarttime;
    values.Player_Count = playercount;
    values.Player_Rate = playerrate;
    values.SelectedSlotId = selectedslotid;
    nextStep();
  };

  function storePlayerAndRateFun(
    playercount,
    playerrate,
    slotstarttime,
    selectedslotid,
    maxPlayers,
    expiry_secs
  ) {
    setPlayerValue(playercount);
    setRateValue(playerrate);
    values.date = datevalue;
    values.time = timerangevalue;
    values.start_time = timerangevalue.start;
    values.end_time = timerangevalue.end;
    values.selectedslot = slotstarttime;
    values.Player_Count = playercount;
    values.Player_Rate = playerrate;
    values.SelectedSlotId = selectedslotid;
    values.hasUserMembership = existingusermembership;
    values.isFMember = isFMember;
    values.maxPlayers = maxPlayers;
    values.expiry_secs = expiry_secs;
    setFormData(values);
    console.log(
      "Going to Personal Info " +
      JSON.stringify({
        AllDATA: values,
      })
    );
    nextStep();
  }

  async function checkBankHoliday(_date = "") {
    if (_date == "") {
      _date = datevalue;
    }
    const qs = require("qs");
    const query = qs.stringify(
      {
        filters: {
          HolidayDate: {
            $eq: moment(_date).format("YYYY-MM-DD"),
          },
          //membership_catergories: { id: { $in: usermembershipData.id } },
        },
        populate: "*",
      },
      {
        encodeValuesOnly: true,
      }
    );
    let isBankHoliday = false;
    let availableforCurrentMem = false;
    await api
      .get("bank-holidays/?" + query)
      .then((response) => {
        console.log("checkBankHoliday-------");
        console.log(response);
        if (response.data.data.length > 0) {
          isBankHoliday = true;
          let bankHMemDta =
            response.data.data[0].attributes.membership_catergories.data.find(
              (singleMem) => singleMem.id === usermembershipData.id
            );
          //console.log("bankHolidayMembership ", bankHMemDta);

          if (typeof bankHMemDta !== "undefined") {
            availableforCurrentMem = true;
          }
          //console.log("bankHolidayMembership ", availableforCurrentMem);
        }
      });

    return { isBankHoliday, availableforCurrentMem };
  }

  async function getUserMembershipData(userEmail) {
    const qs = require("qs");
    const query = qs.stringify(
      {
        populate: "UserID,MembershipID",
        filters: {
          UserID: {
            email: {
              $eq: userEmail,
            },
          },
          Active: true,
        },
      },
      {
        encodeValuesOnly: true,
      }
    );
    await api
      .get("user-memberships/?" + query)
      .then((response) => {
        const usermembershipdatas = response.data.data[0];
        if (typeof usermembershipdatas != "undefined") {
          setExistingUserMembership(true);
          values.hasUserMembership = true;
          if (
            !usermembershipdatas.attributes.MembershipID.IsDefault &&
            !usermembershipdatas.attributes.MembershipID.IsMemberGuest
          ) {
            setIsFMember(false);
            values.isFMember = false;
          }
          //Advance Days Logic
          setUsermembershipData(
            usermembershipdatas.attributes.MembershipID.data
          );
          let membershipData = usermembershipdatas.attributes.MembershipID;

          let mEndDate = usermembershipdatas.attributes.EndDate;
          if (mEndDate === null) {
            mEndDate =
              membershipData.data && membershipData.data.attributes
                ? membershipData.data.attributes.EndDate
                : null;
          }

          let remainingDays = moment(mEndDate).diff(moment(now), "days");

          console.log("Remaining Days- " + remainingDays);
          if (remainingDays >= 0) {
            if (
              membershipData.hasOwnProperty("data") &&
              membershipData.data &&
              membershipData.data.attributes
            ) {
              if (membershipData.data.hasOwnProperty("attributes")) {
                let noOfAdvanceDays =
                  parseInt(membershipData.data.attributes.AdvanceDays) - 1;
                let maxDate = moment(now)
                  .add(noOfAdvanceDays, "days")
                  .format("yyyy-MM-DD");

                if (remainingDays <= 0) {
                  maxDate = moment(mEndDate).format("yyyy-MM-DD");
                  console.log("Max Date - " + maxDate);
                  setMaxDateValue(maxDate);
                } else if (
                  remainingDays >=
                  parseInt(membershipData.data.attributes.AdvanceDays) - 1
                ) {
                  setMaxDateValue(maxDate);
                }

                let start_time = moment(
                  maxDate + "T" + membershipData.data.attributes.StartTime
                ).format("HH:mm");
                let end_time = moment(
                  maxDate + "T" + membershipData.data.attributes.EndTime
                ).format("HH:mm");
                setDefaultTimeRange({ start: start_time, end: end_time });
                setTimeRangeValue({ start: start_time, end: end_time });
              }
            }
          } else {
            maxDate = moment(mEndDate).format("yyyy-MM-DD");
            if (
              membershipData.data &&
              membershipData.data.attributes &&
              membershipData.data.attributes.IsDefault
            ) {
              let noOfAdvanceDays =
                parseInt(membershipData.data.attributes.AdvanceDays) - 1;
              maxDate = moment(now)
                .add(noOfAdvanceDays, "days")
                .format("yyyy-MM-DD");
            }
            setMaxDateValue(maxDate);
          }
          //console.log("UserMembership Data : ", usermembershipdatas);
        }
      })
      .catch((error) => {
        console.log("An error has occured in function getMembership : ", error);
        //setErrorMsg("Some error has occured.");
      });
  }

  // Load the visitor booking policy (site-settings) once on mount. Public
  // `find` permission on the single-type means no auth header is required.
  // Seed the values bag on first mount only. Replaces the in-render
  // `values.hasUserMembership = false` assignment which was racing async
  // membership loads (audit MEDIUM 9).
  useEffect(() => {
    if (typeof values.hasUserMembership === "undefined") {
      values.hasUserMembership = false;
      if (typeof setFormData === "function") setFormData({ ...values });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    api
      .get("site-settings")
      .then((response) => {
        const data = response.data && response.data.data;
        const attrs = data && (data.attributes || data);
        if (attrs) {
          if (typeof attrs.visitor_minimum_players === "number") {
            setVisitorMinPlayers(attrs.visitor_minimum_players);
          }
          if (typeof attrs.visitor_booking_enabled === "boolean") {
            setVisitorBookingEnabled(attrs.visitor_booking_enabled);
          }
        }
      })
      .catch((err) => {
        // Single-type may be unconfigured on a fresh DB; defaults already
        // applied via useState. Don't block the booking page.
        console.warn("site-settings fetch failed; using defaults", err);
      });
  }, []);

  // Load the per-slot visitor minimums for the selected date. The booking page
  // shows one day at a time, so one call resolves every slot's minimum (day +
  // time-of-day rules). Backend stays authoritative; this only drives the UI.
  useEffect(() => {
    if (!datevalue) return;
    const day = moment(datevalue).format("YYYY-MM-DD");
    api
      .get("visitor-minimums/" + day)
      .then((response) => {
        const rows = (response.data && response.data.data) || [];
        const map = {};
        rows.forEach((r) => {
          if (r && r.slot_id != null) map[r.slot_id] = r.minimum;
        });
        setSlotMinMap(map);
      })
      .catch((err) => {
        // Non-fatal: fall back to the global minimum for display.
        console.warn("visitor-minimums fetch failed; using global", err);
        setSlotMinMap({});
      });
  }, [datevalue]);

  // Per-slot tee-sharing state for the date + this booker's audience. Drives
  // hiding of occupied-but-not-joinable (exclusive) tee times and the
  // "others may join" consent on clear slots. Backend stays authoritative.
  useEffect(() => {
    if (!datevalue || !usermembershipData) return;
    const day = moment(datevalue).format("YYYY-MM-DD");
    const audience =
      usermembershipData &&
      usermembershipData.attributes &&
      usermembershipData.attributes.IsDefault
        ? "visitors"
        : "members";
    api
      .get("tee-sharing-state/" + day + "?audience=" + audience)
      .then((response) => {
        const rows = (response.data && response.data.data) || [];
        const map = {};
        rows.forEach((r) => {
          if (r && r.slot_id != null) map[r.slot_id] = r;
        });
        setSharingMap(map);
      })
      .catch((err) => {
        console.warn("tee-sharing-state fetch failed", err);
        setSharingMap({});
      });
  }, [datevalue, usermembershipData]);

  useEffect(() => {
    console.info("User On Pick a date");
    if (token && username) {
      console.info("Username", { user: username });
      getUserMembershipData(username);
    } else {
      console.info("User is not loggedin");
      bookingService.getDefaultMembership().then((result) => {
        let actual_response = result.data.data;
        if (actual_response.length > 0) {
          let noOfAdvanceDays =
            parseInt(actual_response[0].attributes.AdvanceDays) - 1;
          let maxDate = moment()
            .add(noOfAdvanceDays, "days")
            .format("yyyy-MM-DD");
          setMaxDateValue(maxDate);
          setUsermembershipData(actual_response[0]);
          let start_time = moment(
            maxDate + "T" + actual_response[0].attributes.StartTime
          ).format("HH:mm");
          let end_time = moment(
            maxDate + "T" + actual_response[0].attributes.EndTime
          ).format("HH:mm");
          setDefaultTimeRange({ start: start_time, end: end_time });
          setTimeRangeValue({ start: start_time, end: end_time });
        }
      });
    }

    if (values && values.hasOwnProperty("date")) {
      setDateValue(values.date);
    }
  }, []);

  useEffect(() => {
    if (usermembershipData && usermembershipData.hasOwnProperty("attributes")) {
      let selectedDay = moment(datevalue).format("dddd");
      //if (moment(datevalue).diff(start_of_web, "days") >= 0) {
      let date = moment().format("yyyy-MM-DD");
      checkBankHoliday(date).then(
        ({ isBankHoliday, availableforCurrentMem }) => {
          if (!isBankHoliday) {
            if (usermembershipData.attributes[selectedDay]) {
              let start_time = moment(
                date + "T" + usermembershipData.attributes.StartTime
              ).format("HH:mm");
              let end_time = moment(
                date + "T" + usermembershipData.attributes.EndTime
              ).format("HH:mm");
              getTimeSlotData("", start_time, end_time);
            } else {
              setAllSlots([]);
            }
          } else {
            if (availableforCurrentMem) {
              let date = moment().format("yyyy-MM-DD");
              let start_time = moment(
                date + "T" + usermembershipData.attributes.StartTime
              ).format("HH:mm");
              let end_time = moment(
                date + "T" + usermembershipData.attributes.EndTime
              ).format("HH:mm");
              getTimeSlotData("", start_time, end_time);
            } else {
              setAllSlots([]);
            }
          }
        }
      );
      /* } else {
        setAllSlots([]);
      } */
    }
  }, [usermembershipData]);

  useEffect(() => {
    console.log("Time ", timerangevalue);
  }, [timerangevalue]);

  async function getAllTeeTimeData() {
    const qs = require("qs");
    const query = qs.stringify(
      {
        filters: {
          InitialPrice: {
            $notNull: true,
          },
        },
        sort: "InitialPrice",
        pagination: {
          pageSize: 100,
        },
      },
      {
        encodeValuesOnly: true,
      }
    );

    await api
      .get("tee-times/?" + query)
      .then((response) => {
        const teetimedata = response.data.data;
        var timeslot = "";
        if (teetimedata != null) {
          const datalength = response.data.data.length;
          let alltimeSlots = [];
          for (var i = 0; i < datalength; i++) {
            var initialprice = response.data.data[i].attributes.InitialPrice;

            if (
              alltimeSlots.filter(
                (single_price) => single_price == initialprice
              ).length === 0
            ) {
              alltimeSlots.push(initialprice);
            }
          }
        }
      })
      .catch((error) => {
        console.log(
          "An error has occured in function getAllTeeTimeData : ",
          error
        );
        setErrorMsg("Some error has occured.");
      });
  }

  async function getTimeSlotData(date = "", start_time = "", end_time = "") {
    setLoadingSlots(true);
    setBookingAllowed(true);
    setAllSlots([]);
    if (moment(maxDateValue).diff(moment(date), "days") == 0) {
      // Public endpoint (auth:false on backend) — booking-available check.
      await api
        .get("custom-api")
        .then((ts_response) => {
          setLoadingSlots(false);
          setBookingAllowed(ts_response.data.status);
          console.log("Custom API Status", ts_response.data.status);
          if (ts_response.data.status == true) {
            setLoadingSlots(true);
            if (date == "") {
              date = datevalue;
            }
            if (start_time == "") {
              start_time = timerangevalue.start;
            }
            console.log(
              "Date Compare ",
              dateString,
              moment(date).format("YYYY-MM-DD")
            );
            if (dateString == moment(date).format("YYYY-MM-DD")) {
              if (
                moment(date + " " + start_time)
                  .fromNow()
                  .match(/\d+/)[0] > 0
              ) {
                start_time = moment().format("HH:mm");
              }
            }

            if (end_time == "") {
              end_time = timerangevalue.end;
            }
            const qs = require("qs");
            const query = qs.stringify(
              {
                filters: {
                  Date: {
                    $eq: moment(date).format("yyyy-MM-DD"),
                  },
                  StartTime: {
                    $gte: start_time + ":00.000",
                  },
                  EndTime: {
                    $lte: end_time + ":00.000",
                  },
                  // Show fully-open ("Yes") and partially-booked ("Partial")
                  // slots so other players can book the remaining seats. Only
                  // "No" (fully booked) is hidden.
                  AvailableSlots: {
                    $ne: "No",
                  },
                },
                pagination: {
                  pageSize: 100,
                },
              },
              {
                encodeValuesOnly: true,
              }
            );
            /* console.log(
              moment(maxDateValue).diff(moment(date), "days"),
              moment(maxDateValue),
              moment(date)
            ); */
            if (moment(maxDateValue).diff(moment(date), "days") >= 0) {
              api
                .get("tee-time-slots?" + query)
                .then((response) => {
                  setAllSlots(response.data.data);
                  setLoadingSlots(false);
                })
                .catch((error) => {
                  console.log(
                    "An error has Occured in consuming getTimeSlotData",
                    error
                  );
                  setErrorMsg("Some error has occured.");
                });
            } else {
              setAllSlots([]);
              setLoadingSlots(false);
            }
          }
        })
        .catch((error) => {
          console.log("An error has Occured in getTimeSlotData", error);
          setErrorMsg("Some error has occured.");
        });
    } else {
      setLoadingSlots(true);
      if (date == "") {
        date = datevalue;
      }
      if (start_time == "") {
        start_time = timerangevalue.start;
      }
      console.log(
        "Date Compare2 ",
        dateString,
        moment(date).format("YYYY-MM-DD")
      );
      if (dateString == moment(date).format("YYYY-MM-DD")) {
        if (
          moment(date + " " + start_time)
            .fromNow()
            .match(/\d+/) > 0
        ) {
          start_time = moment().format("HH:mm");
        }
      }

      if (end_time == "") {
        end_time = timerangevalue.end;
      }
      const qs = require("qs");
      const query = qs.stringify(
        {
          filters: {
            Date: {
              $eq: moment(date).format("yyyy-MM-DD"),
            },
            StartTime: {
              $gte: start_time + ":00.000",
            },
            EndTime: {
              $lte: end_time + ":00.000",
            },
            // Show fully-open ("Yes") and partially-booked ("Partial").
            // Only "No" (fully booked) is hidden.
            AvailableSlots: {
              $ne: "No",
            },
          },
          pagination: {
            pageSize: 100,
          },
        },
        {
          encodeValuesOnly: true,
        }
      );
      if (moment(maxDateValue).diff(moment(date), "days") >= 0) {
        await api
          .get("tee-time-slots?" + query)
          .then((response) => {
            setAllSlots(response.data.data);
            setLoadingSlots(false);
          })
          .catch((error) => {
            console.log("An error has Occured in getTimeSlotData. ", error);
            setErrorMsg("Some error has occured.");
          });
      } else {
        setAllSlots([]);
        setLoadingSlots(false);
      }
    }
  }

  function generateClick() {
    var playerbtn = document.getElementsByClassName("playerbtn");
    for (var pb = 0; pb < playerbtn.length; pb++) {
      playerbtn[pb].addEventListener("click", function (e) {
        storePlayerAndRateFun(
          e.target.getAttribute("player"),
          e.target.getAttribute("price"),
          e.target.getAttribute("slotstarttime"),
          e.target.getAttribute("slot_id")
        );
      });
    }
  }

  async function selectPlayers(playerCount, slotDetails) {
    // Tee-time sharing consent. Two cases require an explicit tick:
    //  - "clear":   an empty tee time booked for FEWER than the maximum — others
    //               may join later.
    //  - "joining": a tee time that ALREADY has a booking — this party joins the
    //               golfers already on it.
    // Booking all remaining seats on an empty tee time needs no consent (nobody
    // can join). Sharing is always allowed and applies to members and visitors.
    const booked = parseInt(slotDetails.attributes.PlayersBooked || 0, 10) || 0;
    const max =
      parseInt(slotDetails.attributes.MaximumNumberofPlayers || 4, 10) || 4;
    // Sharing is only offered inside an active tee-sharing window for this
    // audience. Outside it, a clear tee time booked below max is simply
    // exclusive (no "others may join" prompt).
    const shareInfo = sharingMap[slotDetails.id];
    const shareable = !!(shareInfo && shareInfo.shareable);
    let context = null;
    if (booked > 0)
      context = "joining"; // only reachable when the slot is joinable (shareable)
    else if (parseInt(playerCount, 10) < max && shareable) context = "clear";

    if (context) {
      // Re-prompt fresh every time (slot/count may have changed).
      setConsentChecked(false);
      setConsentModal({ context, playerCount, slotDetails });
      return;
    }
    await doReserveAndProceed(playerCount, slotDetails, null);
  }

  async function doReserveAndProceed(playerCount, slotDetails, sharedContext) {
    console.log(
      " ON PLAYER SELECTION :: Player Count -" +
      playerCount +
      " Slot Details - " +
      JSON.stringify(slotDetails)
    );

    // Use the signed reservation JWT seeded by Booking.js. If it's missing
    // (Booking.js mint failed) bail rather than send a value the server rejects.
    const reservationCredential = localStorage.getItem("u_b_id_jwt");
    if (!reservationCredential) {
      toast.error("Reservation session expired — please reload the page.");
      return;
    }

    let reserve_query =
      slotDetails.id + "/" + encodeURIComponent(reservationCredential);
    // Public endpoint (auth:false). The reservationCredential is the
    // per-session token the server uses to verify ownership of the hold.
    let reserve_result = await api.get(
      "checkAndReserveSlot/" + reserve_query
    );

    console.log(reserve_result);
    let reservation_result = reserve_result.data.reservation_result;
    if (!reservation_result.success || reservation_result.success == 0) {
      toast.error(reservation_result.message);
      return false;
    }

    // Record the shared-tee-time consent so it carries into the booking payload.
    values.shared_tee_accepted = !!sharedContext;
    values.shared_tee_context = sharedContext || "";

    const slot_starttime = moment(
      slotDetails.attributes.StartTime,
      "HH:mm:ss.SSS"
    ).format("HH:mm");
    if (usermembershipData.attributes.IsDefault) {
      storePlayerAndRateFun(
        playerCount,
        slotDetails.attributes.Price * playerCount,
        slot_starttime,
        slotDetails.id,
        slotDetails.attributes.MaximumNumberofPlayers,
        reservation_result.expiry_secs
      );
    } else {
      storePlayerAndRateFun(
        playerCount,
        0,
        slot_starttime,
        slotDetails.id,
        slotDetails.attributes.MaximumNumberofPlayers,
        reservation_result.expiry_secs
      );
    }
  }

  // Shared-tee-time consent messages (standard copy; can be reworded later).
  const CONSENT_MESSAGES = {
    clear:
      "When booking, if the day becomes busy you may have other golfers join your tee time. Please tick below to accept the position or seek an alternative tee time or book for more players.",
    joining:
      "Please note that this tee time already has a booking on it and you will be joining those golfers in that tee time. Please tick below to accept the position or seek an alternative tee time.",
  };

  const onConsentAccept = async () => {
    if (!consentModal || !consentChecked) return;
    const { context, playerCount, slotDetails } = consentModal;
    setConsentModal(null);
    await doReserveAndProceed(playerCount, slotDetails, context);
  };

  return (
    <div className="w-full px-[10px] md:px-[50px] py-4 bg-[#fafafa] overflow-hidden">
      {consentModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 px-4">
          <div className="bg-white rounded-lg shadow-xl max-w-lg w-full p-6">
            <h3 className="text-[20px] font-semibold text-[#4E4E4E] mb-3">
              {consentModal.context === "joining"
                ? "Joining an existing tee time"
                : "You may be joined on this tee time"}
            </h3>
            <p className="text-[15px] text-[#707070] mb-4">
              {CONSENT_MESSAGES[consentModal.context]}
            </p>
            <label className="flex items-start gap-2 mb-5 cursor-pointer">
              <input
                type="checkbox"
                className="mt-1"
                checked={consentChecked}
                onChange={(e) => setConsentChecked(e.target.checked)}
              />
              <span className="text-[14px] text-[#4E4E4E]">
                I accept the position on this tee time.
              </span>
            </label>
            <div className="flex gap-3 justify-end">
              <button
                type="button"
                className="px-4 py-2 rounded border border-gray-300 text-[#4E4E4E]"
                onClick={() => {
                  setConsentModal(null);
                  setConsentChecked(false);
                }}
              >
                Seek an alternative
              </button>
              <button
                type="button"
                disabled={!consentChecked}
                className={
                  "px-4 py-2 rounded text-white " +
                  (consentChecked
                    ? "bg-[#17BA17] hover:bg-[#149a14] cursor-pointer"
                    : "bg-gray-300 cursor-not-allowed")
                }
                onClick={onConsentAccept}
              >
                Accept &amp; continue
              </button>
            </div>
          </div>
        </div>
      )}
      <div className="bg-white rounded shadow-xl">
        <div className="w-full flex flex-col">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 px-[20px] lg:px-[50px] py-[20px] lg:py-[30px]">
            <div className="h-fit w-full bg-white shadow-md border border-gray-200 rounded-lg px-[20px] py-[10px] lg:px-[40px] lg:py-[50px]">
              <div className="grid grid-cols-1 gap-6">
                <label className="block">
                  <div className="text-[#707070] font-medium text-[18px]">
                    Select Date
                  </div>
                  {/* <input
                    type="date"
                    className="mt-1 block w-full rounded-md bg-[#ebebeb] border-transparent focus:border-gray-500 focus:bg-white focus:ring-0"
                    id="pick_date"
                    value={datevalue}
                    min={minDateValue}
                    max={maxDateValue}
                    onChange={(e) => dateChangeHandler(e.target.value)}
                  /> */}
                  <DatePicker
                    dateFormat="dd/MM/yyyy"
                    selected={moment(datevalue).toDate()}
                    minDate={moment(minDateValue).toDate()}
                    maxDate={moment(maxDateValue).toDate()}
                    onChange={(update) => {
                      dateChangeHandler(update);
                    }}
                    customInput={<DateCustomInput ref={ref} />}
                  />
                </label>
                <label className="block">
                  <span className="text-[#707070] font-medium text-[18px]">
                    Time Range
                  </span>
                  <div>
                    <TimeRangeSlider
                      disabled={false}
                      format={24}
                      maxValue={defaultTimeRange.end}
                      minValue={defaultTimeRange.start}
                      name={"time_range"}
                      onChange={timeChangeHandler}
                      onChangeComplete={changeCompleteHandler}
                      step={10}
                      value={timerangevalue}
                    />
                  </div>
                </label>
                <label className="block text-center">
                  <button
                    type="button"
                    className="bg-[#EBEBEB] rounded-md py-2 px-[25px] text-[#4E4E4E] text-[18px] font-medium"
                  >
                    <span id="start_time">{timerangevalue.start}</span> to{" "}
                    <span id="end_time">{timerangevalue.end}</span>
                  </button>
                </label>
                <label className="block">
                  <p className="font-[14px] pt-[5px] text-[#ff0000] text-center">
                    {errormsg}
                  </p>
                </label>
              </div>
            </div>
            {loadingSlots && (
              <div className="text-center">
                <svg
                  className="animate-spin align-text-bottom inline-block h-[24px] w-[24px] mr-2 text-blue"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                  ></circle>
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  ></path>
                </svg>
                <h2 className="inline-block text-[24px] text-[#4E4E4E] font-semibold text-center">
                  Loading slots...
                </h2>
              </div>
            )}
            {!loadingSlots && (
              <div
                className="w-full bg-white shadow-md border border-gray-200 rounded-lg px-[20px] py-[10px] lg:px-[20px] lg:py-[30px] place-items-center"
                id="main_timming_slot_div"
              >
                {bookingAllowed == false && (
                  <h2 className="text-[24px] text-[#4E4E4E] font-semibold text-center">
                    Sorry, booking is not allowed between 12:00am - 08:00am
                  </h2>
                )}
                {bookingAllowed == true && allSlots.length === 0 && (
                  <h2 className="text-[24px] text-[#4E4E4E] font-semibold text-center">
                    Sorry, slots are not available for{" "}
                    {moment(datevalue).format("dddd")}
                  </h2>
                )}
                <div className="grid grid-cols-3 md:grid-cols-5 gap-2 place-items-center mb-6 price_timming">
                  {allSlots
                    .filter((single_slot) => {
                      // Hide tee times that are occupied but not joinable by
                      // this audience (exclusive once booked outside a sharing
                      // window). Clear and joinable slots stay visible.
                      const si = sharingMap[single_slot.id];
                      return !(si && si.hide);
                    })
                    .map((single_slot, idx) => {
                    // Compute remaining capacity and effective player-count
                    // bounds for this slot. Members can pick any count up to
                    // remaining; visitors must meet the policy minimum,
                    // capped by remaining so the last seat(s) are bookable.
                    const _max = parseInt(
                      single_slot.attributes.MaximumNumberofPlayers
                    );
                    const _booked = parseInt(
                      single_slot.attributes.PlayersBooked || 0
                    );
                    const _remaining = Math.max(0, _max - _booked);
                    const _isVisitor =
                      usermembershipData &&
                      usermembershipData.attributes &&
                      usermembershipData.attributes.IsDefault;
                    const _slotMin =
                      slotMinMap[single_slot.id] != null
                        ? slotMinMap[single_slot.id]
                        : visitorMinPlayers;
                    const _lowerBound = _isVisitor
                      ? Math.min(Math.max(1, _slotMin || 1), _remaining)
                      : 1;
                    var playerRows = [];
                    for (var i = _lowerBound; i <= _remaining; i++) {
                      const PlayerNo = i;
                      if (
                        usermembershipData &&
                        usermembershipData.attributes &&
                        usermembershipData.attributes.IsDefault
                      ) {
                        playerRows.push(
                          <p
                            key={i}
                            className="w-full text-[#17BA17] bg-[#ffffff] border-[#17BA17] border hover:bg-[#17BA17] hover:text-[#ffffff] rounded py-1 mb-1 playerbtn cursor-pointer"
                            onClick={(e) =>
                              selectPlayers(PlayerNo, single_slot)
                            }
                          >
                            {" "}
                            {i +
                              " Player - \u00A3" +
                              parseInt(single_slot.attributes.Price) * i}{" "}
                          </p>
                        );
                      } else {
                        playerRows.push(
                          <p
                            key={i}
                            className="w-full text-[#17BA17] bg-[#ffffff] border-[#17BA17] border hover:bg-[#17BA17] hover:text-[#ffffff] rounded py-1 mb-1 playerbtn cursor-pointer"
                            onClick={(e) =>
                              selectPlayers(PlayerNo, single_slot)
                            }
                          >
                            {" "}
                            {i + " Player - \u00A30"}{" "}
                          </p>
                        );
                      }
                    }

                    let previousHeading = teeTimeHeading;
                    teeTimeHeading =
                      "TEE TIMES FOR \u00A3" +
                      parseInt(single_slot.attributes.Price);

                    if (previousHeading != teeTimeHeading) {
                      previousSlot = single_slot;
                      return (
                        <div key={"hdr-" + (single_slot.id || idx)} className="col-span-full">
                          <h2 className="text-[24px] text-[#4E4E4E] font-semibold text-center mb-3">
                            {teeTimeHeading}
                          </h2>
                        </div>
                      );
                    } else {
                      if (previousSlot.hasOwnProperty("attributes")) {
                        let copyPSlot = previousSlot;
                        const _pMax = parseInt(
                          previousSlot.attributes.MaximumNumberofPlayers
                        );
                        const _pBooked = parseInt(
                          previousSlot.attributes.PlayersBooked || 0
                        );
                        const _pRemaining = Math.max(0, _pMax - _pBooked);
                        const _pIsVisitor =
                          usermembershipData &&
                          usermembershipData.attributes &&
                          usermembershipData.attributes.IsDefault;
                        const _pSlotMin =
                          slotMinMap[previousSlot.id] != null
                            ? slotMinMap[previousSlot.id]
                            : visitorMinPlayers;
                        const _pLowerBound = _pIsVisitor
                          ? Math.min(Math.max(1, _pSlotMin || 1), _pRemaining)
                          : 1;

                        var previousPlayerRows = [];
                        for (var i = _pLowerBound; i <= _pRemaining; i++) {
                          const PlayerNo = i;
                          if (
                            usermembershipData &&
                            usermembershipData.attributes &&
                            usermembershipData.attributes.IsDefault
                          ) {
                            previousPlayerRows.push(
                              <p
                                key={i}
                                className="w-full text-[#17BA17] bg-[#ffffff] border-[#17BA17] border hover:bg-[#17BA17] hover:text-[#ffffff] rounded py-1 mb-1 playerbtn cursor-pointer"
                                onClick={(e) =>
                                  selectPlayers(PlayerNo, copyPSlot)
                                }
                              >
                                {" "}
                                {i +
                                  " Player - \u00A3" +
                                  parseInt(previousSlot.attributes.Price) *
                                  i}{" "}
                              </p>
                            );
                          } else {
                            previousPlayerRows.push(
                              <p
                                key={i}
                                className="w-full text-[#17BA17] bg-[#ffffff] border-[#17BA17] border hover:bg-[#17BA17] hover:text-[#ffffff] rounded py-1 mb-1 playerbtn cursor-pointer"
                                onClick={(e) =>
                                  selectPlayers(PlayerNo, copyPSlot)
                                }
                              >
                                {" "}
                                {i + " Player - \u00A30"}{" "}
                              </p>
                            );
                          }
                        }
                        previousSlot = {};
                        return (
                          <div
                            key={"pair-" + (copyPSlot.id || "") + "-" + (single_slot.id || idx)}
                            className="col-span-2 inline-grid grid-cols-2 justify-items-stretch gap-2 price_timming"
                            style={{ display: "contents" }}
                          >
                            <div className="w-full">
                              <div
                                className={
                                  "w-full border border-[#17BA17] text-[#17BA17] lg:text-[20px] sm:text-[12px] font-medium text-center lg:px-4 sm:px-2 py-2 rounded hover:bg-[#17BA17] hover:text-[#ffffff] group relative cursor-pointer"
                                }
                              >
                                {moment(
                                  copyPSlot.attributes.StartTime,
                                  "HH:mm:ss.SSS"
                                ).format("HH:mm")}
                                {_pBooked > 0 && (
                                  <span className="block text-[10px] font-normal opacity-80">
                                    {_pRemaining} of {_pMax} left
                                  </span>
                                )}
                                <div
                                  className={
                                    "invisible group-hover:visible absolute border border-[#A1E4A1] rounded bg-[#A1E4A1] w-[200px] px-1 py-1 z-10"
                                  }
                                >
                                  {previousPlayerRows}
                                </div>
                              </div>
                            </div>
                            <div className="w-full">
                              <div
                                className={
                                  "w-full border border-[#17BA17] text-[#17BA17] lg:text-[20px] sm:text-[12px] font-medium text-center lg:px-4 sm:px-2 py-2 rounded hover:bg-[#17BA17] hover:text-[#ffffff] group relative cursor-pointer"
                                }
                              >
                                {moment(
                                  single_slot.attributes.StartTime,
                                  "HH:mm:ss.SSS"
                                ).format("HH:mm")}
                                {_booked > 0 && (
                                  <span className="block text-[10px] font-normal opacity-80">
                                    {_remaining} of {_max} left
                                  </span>
                                )}
                                <div
                                  className={
                                    "invisible group-hover:visible absolute border border-[#A1E4A1] rounded bg-[#A1E4A1] w-[200px] px-1 py-1 z-10"
                                  }
                                >
                                  {playerRows}
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      } else {
                        return (
                          <div key={"slot-" + (single_slot.id || idx)} className="w-full">
                            <div
                              className={
                                "w-full border border-[#17BA17] text-[#17BA17] lg:text-[20px] sm:text-[12px] font-medium text-center lg:px-4 sm:px-2 py-2 rounded hover:bg-[#17BA17] hover:text-[#ffffff] group relative cursor-pointer"
                              }
                            >
                              {moment(
                                single_slot.attributes.StartTime,
                                "HH:mm:ss.SSS"
                              ).format("HH:mm")}
                              {_booked > 0 && (
                                <span className="block text-[10px] font-normal opacity-80">
                                  {_remaining} of {_max} left
                                </span>
                              )}
                              <div
                                className={
                                  "invisible group-hover:visible absolute border border-[#A1E4A1] rounded bg-[#A1E4A1] w-[200px] px-1 py-1 z-10"
                                }
                              >
                                {playerRows}
                              </div>
                            </div>
                          </div>
                        );
                      }
                    }
                  })}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
